if (!customElements.get('kvr-pillars')) {
  customElements.define('kvr-pillars', class extends HTMLElement {
    connectedCallback() {
      this.images = [...this.querySelectorAll('[data-pillar-image]')];
      this.copies = [...this.querySelectorAll('[data-pillar-copy]')];
      this.dots = [...this.querySelectorAll('[data-pillar-dot]')];
      this.number = this.querySelector('[data-pillar-number]');
      this.activeIndex = -1;
      this.ticking = false;

      if (!this.images.length) return;
      this.setActive(0);
      this.onScroll = this.requestUpdate.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.updateFromScroll();
    }

    requestUpdate() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.updateFromScroll();
        this.ticking = false;
      });
    }

    updateFromScroll() {
      if (window.matchMedia('(max-width: 749px)').matches) return;

      const rect = this.getBoundingClientRect();
      const scrollDistance = Math.max(this.offsetHeight - window.innerHeight, 1);
      const travelled = Math.min(Math.max(-rect.top, 0), scrollDistance);
      const progress = travelled / scrollDistance;
      const index = Math.min(
        this.images.length - 1,
        Math.floor(progress * this.images.length)
      );

      this.setActive(index);
    }

    setActive(index) {
      if (index === this.activeIndex) return;
      this.activeIndex = index;
      [this.images, this.copies, this.dots].forEach((items) => {
        items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
      });
      if (this.number) this.number.textContent = String(index + 1).padStart(2, '0');
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
  });
}
